export default "__VITE_ASSET__A2r2sn0h__"